// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button.reset[data-v-a3190a3a]{display:block;width:200px;margin:0 auto;color:var(--base-link);margin-bottom:1rem;text-align:center;height:32px;line-height:32px}button.reset svg[data-v-a3190a3a]{margin-right:.5rem;height:20px;margin-bottom:-4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
